import { put, call, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../constants';
import { AxiosService } from '../../services';
import { actionTypes } from '../../types';
import { userListFilterFailure, userListFilterSuccess } from '../../actions/userActions/userListActions';
import store from '../../configStore';

function* userListFilter({ payload }) {
    console.log('====================================');
    try {
        const response = yield call(AxiosService, {
            method: 'post',
            base_url: base_url,
            endPoint: endpoints.getUsersListWithFilters,
            payload: payload,
            isAuth: true,
        });
        console.log('====================================');
        console.log("GET_USER_LIST_FILTER_SUCCESS status :", response.data.status);
        console.log("GET_USER_LIST_FILTER_SUCCESS data :", response.data.response);
        console.log("GET_USER_LIST_FILTER_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            userListFilterSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
    } catch (error) {
        console.log('====================================');
        console.log("GET_USER_LIST_FILTER_FAILURE status :", error?.response?.status);
        console.log("GET_USER_LIST_FILTER_FAILURE data:", error?.response?.data);
        console.log("GET_USER_LIST_FILTER_FAILURE error :", error);
        console.log('====================================');
        yield put(userListFilterFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* userListFilterSaga() {
    yield takeLatest(actionTypes.GET_USER_LIST_FILTER_REQUEST, userListFilter);
}

export default userListFilterSaga;
